import getHelper from "../helpers/getHelper";
import configs from "../helpers/configs";

const calculateAllAmounts = async (openOrders) => {
  const { baseUrl } = configs;
  const res = await getHelper(`${baseUrl}/projectedbalance`);
  return res.data.amount;
};

export default calculateAllAmounts;
